export const ADP_BARGE_AUDIT_HISTORY_NS = 'components/AdpBargeAuditHistory';

export const i18n = {
  en: {
    terminalLoadingQuantity: 'Loaded quantity',
    priorRobQuantity: 'Prior ROB quantity',
    deliveryQuantity: 'Delivery quantity',
    scheduledQuantity: 'Scheduled quantity',
    robQuantity: 'ROB quantity',
    cycleStatus: 'Cycle status',
    residualQuantity: 'Residual quantity',
    bargeLoading: 'Barge loading',
    bargeAuditHistory: {
      title: 'Barge audit history',
      xAxisLabel: {
        qualityAnalysis: 'Fuel quality results',
      },
      massFlowMeter: {
        title: 'Delivery profile',
        noData: 'No data to display',
      },
      qualityAnalysis: {
        title: 'Fuel quality results for this operation',
      },
      tooltip:
        'The calculated residual quantity and cycle difference are presented exclusively for completed cycles, once all data for the cycle is available.',
    },
    cycleResidualTooltip:
      'Green indicates more quantity delivered than measured. Red indicates less quantity delivered than measured.',
    modal: {
      deliveryDocuments: 'Delivery documents',
      attachments: 'Barge loading quantity',
    },
    expected: 'Expected quantity',
    expectedRobQuantity: 'Expected ROB quantity',
    columns: {
      docName: 'Document Name',
      date: 'Date',
    },
    actions: {
      download: 'Download',
    },
    zip: {
      title: 'Attachment',
    },
  },
};
